import React, { useState, useEffect, useRef } from "react";

import { ReactComponent as ArrowRight } from "../../../../assets/icons/arrowright.svg";
import { ReactComponent as ArrowLeft } from "../../../../assets/icons/arrowleft.svg";
import { ReactComponent as Spinner } from "../../../../assets/icons/spinner.svg";
import { ReactComponent as MapPad } from "../../../../assets/images/signUp/man-with-pad.svg";
import Logo from "../../Logo";
import { SideSVG } from "../../../common";
import { useSelector, useDispatch } from "react-redux";
import {
  useCreateCompanyMutation,
  useIndividualCompanyMutation,
} from "../../../../store/Company/companyApiSlice";
import { setCompanyData } from "../../../../store/Company/companySlice";
import { Countries } from "../../Home/CountryFlag";
import { ReactComponent as GPS } from "../../../../assets/icons/GPS.svg";
import { ReactComponent as Magnifier } from "../../../../assets/icons/Magnifier.svg";
import { setFilledCompany } from "../../../../store/claim/claimSlice";
import useCountryCode from "../../../../Hooks/useCountryCode";
import { setCountryData } from "../../../../store/search/searchSlice";


const CompanyNotFound = ({ onNext, handleSwitch }) => {
  const {countryCode} = useCountryCode()
  const [displayUl, setDisplayUl] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [country, setCountry] = useState({
    name: "Select Country",
    flag: null,
    code: null,
  });
  const dropdownRef = useRef(null);

  const handleCountrySelect = (countryCode) => {
    const countryData = Countries.find(country => country.code === countryCode);
    const countryDetail = {
      name: countryData.name,
      flag: countryData.file_url,
      code: countryData.code,
    };
    dispatch(setCountryData(countryDetail));
    setCountry(countryDetail)
  }

  // useEffect(() => {
  //   if (countryCode && country.code !== countryCode ) {
  //     handleCountrySelect(countryCode)
  //   }
  // }, [])


  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDisplayUl(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);
  const [error, setSearchError] = useState(false);
  const dispatch = useDispatch();
  const companyNameRef = useRef();

  const { token, userInfo } = useSelector((state) => state.auth);

  //company register
  const [createCompany, { isLoading: companyCreating }] =
    useCreateCompanyMutation();

  const [individualCompany] = useIndividualCompanyMutation();

  const handleCountry = (e, flag, option) => {
    const countryDetail = {
      name: option.name,
      flag: option.file_url,
      code: option.code,
    };
    setCountry(countryDetail);
    setDisplayUl(!displayUl);
  };

  const handleDisplayUl = (e) => {
    e.preventDefault();
    setDisplayUl(!displayUl);
  };

  //search filter
  const handleFilteredData = (event) => {
    const searchLetters = event.target.value;
    setSearchTerm(searchLetters);

    const filteredData = Countries.filter((item) =>
      item.name.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredData(filteredData);
  };

  //handle location popup
  const handleLocationPopup = async (e) => {
    e.preventDefault();
    try {
     handleCountrySelect(countryCode);
    } catch (error) {
    }
    setDisplayUl(false);

  };



  const handleCompanySave = async () => {
    if (companyNameRef.current.value === "") {
      setSearchError(true);
      return;
    }
    setSearchError(false);

    try {
      const jsonData = {
        registered_company_name: companyNameRef.current.value,
        wb_win: '',
        country_code: country.code,
        new_company: 1
      };
      dispatch(setFilledCompany(jsonData))
      onNext();
    } catch (error) {
    }
  };

  return (
    <section className="relative px-4 sm:px-0 py-20 lg:py-0 overflow-hidden">
      <div className="px-0 mx-auto">
        <div className="mx-auto relative">
          <Logo />
          <div className="flex -mx-4 xl:items-center items-center max-h-screen">
            <div className="flex-flex1 w-full lg:w-1/2 xl:w-3/5 px-4 order-last lg:order-first">
              <div className="max-w-md py-20 mx-auto ">
                <h3 className="font-heading text-f36 text-primary font-bold mb-4 text-center">
                  Enter your Business Legal name
                </h3>
                <p className="text-f18 text-secondarytwo mb-4">
                  Make sure to enter the business name correctly that is mention
                  in your registration license{" "}
                </p>
                <form>
                  <label
                    for="search-dropdown"
                    className="block mb-1 text-sm text-secondarytwo font-semibold text-left"
                  >
                    Select Country
                  </label>

                  <div className="flex my-2 mb-6" ref={dropdownRef}>
                    <div
                      className="w-full justify-between cursor-pointer truncate flex-shrink-0 z-10 inline-flex items-center py-2.5 px-4 text-sm font-medium text-center text-gray-900 bg-gray-100 border border-gray-300 rounded-lg hover:bg-gray-200 focus:ring-gray-300 "
                      onClick={handleDisplayUl}
                    >
                      <div
                        className="cursor-pointer flex text-left text-xs overflow-hidden"
                        role="presentation"
                      >
                        {country?.flag && (
                          <img
                            src={country.flag}
                            width="20px"
                            height="20px"
                            className="mr-2 h-5"
                            alt="hello"
                          />
                        )}
                        {country?.name}
                      </div>
                      <ArrowLeft
                        className={displayUl ? "rotate-90" : "-rotate-90"}
                      />
                    </div>
                    <div
                      className={`${displayUl ? "" : "hidden"
                        } shadow-boxPopup rounded-md mt-12 w-96 bg-white p-5 sm:max-h-84 sm:min-h-fit absolute z-10`}
                    >
                      <div
                        className="text-link border-b border-slate p-3 mb-3 font-semibold cursor-pointer items-center flex"
                        onClick={handleLocationPopup}
                      >
                        <GPS className="mr-3" /> Detect using GPS
                      </div>
                      <div className="flex items-center">
                        <Magnifier className="absolute mb-3 mx-3" />

                        <input
                          type="text"
                          className="border-input border w-full p-2 px-11 mb-3 shadow-search rounded"
                          onKeyUp={handleFilteredData}
                        />
                      </div>
                      <ul className="overflow-y-auto shadow-boxPopup border-greyFade border sm:max-h-64 sm:min-h-fit rounded-md">
                        {filteredData.map((option) => (
                          <li
                            onClick={(e) =>
                              handleCountry(
                                e.target.innerText,
                                option.file_url,
                                option
                              )
                            }
                            className="px-4 py-3 cursor-pointer hover:bg-input flex text-left text-xs"
                            role="presentation"
                          >
                            <img
                              src={option.file_url}
                              width="20px"
                              height="20px"
                              className="mr-2 h-5"
                              alt="hello"
                            />
                            {option.name}
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                  <label
                    for="search-dropdown"
                    className="block mb-1 text-sm text-secondarytwo font-semibold text-left"
                  >
                    Enter business name
                  </label>
                  <div className="flex mt-2 mb-2">
                    <div className="relative w-full">
                      <input
                        type="text"
                        id="search-dropdown"
                        className="block p-2.5 w-full z-20 text-sm text-gray-900 bg-gray-50 rounded-md border border-gray-300 "
                        placeholder="Enter your business name"
                        required
                        ref={companyNameRef}
                      />
                    </div>
                  </div>
                </form>
                {error && (
                  <p className="text-red-500 text-sm text-left py-2">
                    Business name can't be blank.
                  </p>
                )}
                <div className="flex justify-between gap-2 mt-4">
                  <button
                    className="inline-flex items-center justify-start mr-2 gap-4 text-primaryText font-bold w-full"
                    onClick={handleSwitch}
                  >
                    <ArrowLeft />
                    <span className="relative">Go Back</span>
                  </button>
                  <button
                    className={`relative group w-full py-3 px-5 text-center text-sm font-semibold text-white bg-primary rounded-md  inline-flex items-center justify-center gap-4 `}
                    type="submit"
                    onClick={handleCompanySave} 
                  >
                    <span className="relative">
                      {companyCreating ? <Spinner /> : "Save & Continue"}
                    </span>
                    <ArrowRight />
                  </button>
                </div>
              </div>
            </div>

            <SideSVG SVG={MapPad} positions="bottom-0  left-[-25%]" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default CompanyNotFound;
